// Add to cart CTA color change | Desktop and Mobile
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product-single__form .payment-buttons button.btn.btn--full.add-to-cart')
    .forEach(function (button) {
      button.addEventListener('click', function () {
        if (typeof campaign !== 'undefined' && campaign.trigger) {
          campaign.trigger('clicked.addtocart');
        }
      });
    });

  
});

// Category Icons | Desktop 
const catIconsDesktop = false;
if(catIconsDesktop) {
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof jQuery !== "undefined") {
      const $ = jQuery; // Ensure jQuery is used instead of Zepto
  
      const ccData = [
        { url: 'https://onpaylessfurniture.ca/collections/bedroom', name: 'Bedroom', img: 'https://cdn.convertcart.com/uploads/5a18a3bb.png' },
        { url: 'https://onpaylessfurniture.ca/collections/mattress-and-box-spring', name: 'Bedding', img: 'https://cdn.convertcart.com/uploads/4ef8ba38.png' },
        { url: 'https://onpaylessfurniture.ca/collections/couches-sofas', name: 'Living', img: 'https://cdn.convertcart.com/uploads/a3b97c1f.png' },
        { url: 'https://onpaylessfurniture.ca/collections/dining-room', name: 'Dining', img: 'https://cdn.convertcart.com/uploads/3e4bc509.png' },
        { url: 'https://onpaylessfurniture.ca/collections/office-furniture', name: 'Office', img: 'https://cdn.convertcart.com/uploads/724b44c0.png' },
        { url: 'https://onpaylessfurniture.ca/collections/canadian-made', name: 'Made In Canada', img: 'https://cdn.convertcart.com/uploads/ee663664.png' },
        { url: 'https://onpaylessfurniture.ca/collections/best-sellers', name: 'Bestsellers', img: 'https://cdn.convertcart.com/uploads/bd42dbdd.png' }
      ];
  
      $('.site-nav').addClass('ccCamp86988526');
  
      const ccDiv = (ccIn) => `
        <span class="cc-box">
          <span class="cc-image">
            <img src="${ccIn.img}" alt="${ccIn.name}">
          </span>
          <span class="cc-text">${ccIn.name}</span>
        </span>`;
  
      $('.ccCamp86988526 > li.site-nav__item > a').each(function (index) {
        if (ccData[index]) {
          $(this).html(ccDiv(ccData[index]));
        }
      });
  
      const call = $('.ccCamp86988526 .call-us__bottom.callus');
      $('.header-item.header-item--icons .ccCamp86988526').prepend(call);
  
      $('.ccCamp86988526 .call-us__bottom.callus').on('click', function () {
        if (typeof campaign !== 'undefined' && campaign.trigger) {
          campaign.trigger('clicked.callus');
        }
      });
  
      $('.ccCamp86988526 > li.site-nav__item > a').on('click', function () {
        const ccEvent = $(this).find('.cc-text').text().toLowerCase();
        if (typeof campaign !== 'undefined' && campaign.trigger) {
          campaign.trigger(`clicked.${ccEvent}`);
        }
      });
  
      $('.ccCamp86988526 .megamenu__col a').on('click', function () {
        const ccEvent = $(this).text().toLowerCase();
        if (typeof campaign !== 'undefined' && campaign.trigger) {
          campaign.trigger(`clicked.${ccEvent}`);
        }
      });
  
      $('.ccCamp86988526 li.site-nav--is-megamenu').eq(0).addClass('cc-change');
      $('.ccCamp86988526 .cc-box:first-child').css('padding-left', '0px');
    }
  });
  
}

// Category Icons | Mobile
const catIconsMobile = false;
if(catIconsMobile) {
  var $ = require('zepto');
  const { randId } = campaign;
  const ccSel = $(`#${randId}ccCamp01614032`);
  const Siema = require('siema');
  let slideIndex;
  let _perPage;
  let sliderLength;
  const dataLength = 8;

  const updateArrow = () => {
    ccSel.find('.cc-left').removeClass('cc-grayarrow');
    ccSel.find('.cc-right').removeClass('cc-grayarrow');
    if (slideIndex == sliderLength) {
      ccSel.find('.cc-right').addClass('cc-grayarrow');
    }
    if (slideIndex == 0) {
      ccSel.find('.cc-left').addClass('cc-grayarrow');
    }
  };
  ccSel.find('.cc-box').on('click', function () {
    const ccEvent = $(this).find('span').text().toLowerCase();
    campaign.trigger(`clicked.${ccEvent}`);
  });

  async function ccInitSlider() {
    const ccSlider = new Siema({
      selector: '.cc-slide60778563',
      perPage: {
        300: 3,
        365: 3,
        380: 4,
        600: 5,
      },
      loop: false,
      duration: 400,
      easing: 'ease-out',
    });
    slideIndex = ccSlider.currentSlide;
    _perPage = ccSlider.perPage;
    sliderLength = dataLength - _perPage;
    updateArrow();
    ccSel.find('.cc-left').on('click', (e) => {
      e.preventDefault();
      ccSlider.prev();
      ccSlider.prev();
      slideIndex = ccSlider.currentSlide;
      updateArrow();
      campaign.trigger('clicked.previous');
    });
    ccSel.find('.cc-right').on('click', (e) => {
      e.preventDefault();
      ccSlider.next();
      ccSlider.next();
      slideIndex = ccSlider.currentSlide;
      updateArrow();
      campaign.trigger('clicked.next');
    });
  }

  $('.ccCamp01614032')
    .find('.cc-box')
    .forEach((val, i) => {
      $('.ccCamp01614032 .cc-box')
        .eq(i)
        .on('click', () => {
          if (
            $('.ccCamp01614032 .cc-box')
              .eq(i)
              .find('.cc-arrow-top')
              .css('display') != 'block'
          ) {
            $('.ccCamp01614032 .cc-box').removeClass('cc-show');
            $('.ccCamp01614032 .cc-black-wrap').removeClass('cc-showblack');
            $('.ccCamp01614032 .cc-box')
              .eq(i)
              .addClass('cc-show');
            $('.ccCamp01614032 .cc-black-wrap')
              .eq(i)
              .addClass('cc-showblack');
            $('body').addClass('cc-open61449234');
          } else {
            $('.ccCamp01614032 .cc-box').removeClass('cc-show');
            $('.ccCamp01614032 .cc-black-wrap').removeClass('cc-showblack');
            $('body').removeClass('cc-open61449234');
          }
        });
    });

  $('.ccCamp01614032')
    .find('.cc-black')
    .forEach((val, i) => {
      $('.ccCamp01614032')
        .find('.cc-black')
        .eq(i)
        .on('click', () => {
          if (
            $('.ccCamp01614032 .cc-black')
              .eq(i)
              .find('.cc-yellow-wrap')
              .css('display') != 'block'
          ) {
            $('.ccCamp01614032 .cc-black').removeClass('cc-showyellow');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .text('+');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .removeClass('cc-minus');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .css('right', '20px;');
            $('.ccCamp01614032 .cc-black')
              .eq(i)
              .addClass('cc-showyellow');
            $('.ccCamp01614032 .cc-black')
              .eq(i)
              .find('.cc-plus')
              .text('-');
            $('.ccCamp01614032 .cc-black')
              .eq(i)
              .find('.cc-plus')
              .addClass('cc-minus');
            $('.ccCamp01614032 .cc-black')
              .eq(i)
              .find('.cc-plus')
              .css('right', '20px;');
          } else {
            $('.ccCamp01614032 .cc-black').removeClass('cc-showyellow');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .text('+');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .removeClass('cc-minus');
            $('.ccCamp01614032 .cc-black')
              .find('.cc-plus')
              .css('right', '20px;');
          }
        });
    });

  $('body').on('click', (e) => {
    if (e.target.id != 'cc-image' && e.target.id != 'cc-block') {
      $('.ccCamp01614032 .cc-box').removeClass('cc-show');
      $('.ccCamp01614032 .cc-black-wrap').removeClass('cc-showblack');
      $('body').removeClass('cc-open61449234');
    }
  });

  $('.ccCamp01614032 .cc-plus').on('click', (e) => {
    e.preventDefault();
  });

  $('.ccCamp01614032 .cc-black span').on('click', function () {
    const ccEvent = $(this).text().toLowerCase();
    campaign.trigger(`clicked.${ccEvent}`);
  });
  $('.ccCamp01614032 .cc-yellow').on('click', function () {
    const ccEvent = $(this).find('a').eq(0).text()
      .toLowerCase();
    campaign.trigger(`clicked.${ccEvent}`);
  });

  // const call = $('.call-us__bottom.callus').eq(0);
  // $('.site-header__element .header-layout').after(call);
  (async () => {
    await ccInitSlider();
  })();
  $(document).ready(function () {
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
      const st = $(this).scrollTop();
      if (st > lastScrollTop && st > 200) {
        $('body').removeClass('ccPageScrolledUp');
      } else if (st <= 200) {
        $('body').removeClass('ccPageScrolledUp');
      } else {
        $('body').addClass('ccPageScrolledUp');
      }

      lastScrollTop = st;
    });
  });
}

